import classNames from 'classnames';
import styles from './SelectPropertyOwnership.module.scss';
import FlexContainer from '../FlexContainer';
import { ownershipTypeOptions } from '../../config/userFields';
import InfoMessageBlock from '../InfoMessageBlock';

/**
 * SelectPropertyOwnership
 *
 * @return {JSX.Element}
 */
const SelectPropertyOwnership = ({
  className,
  value,
  name,
  onChange,
  required,
}) => {
  const handleClick = (key) => () => onChange({ target: { name, value: key } });

  return (
    <FlexContainer
      className={classNames(
        styles.SelectPropertyOwnership,
        className,
        SelectPropertyOwnership.displayName
      )}
      column
      gap
    >
      {ownershipTypeOptions.map((o) => (
        <InfoMessageBlock
          key={o.key}
          title={o.value}
          description={o.description}
          black={value === o.key}
          onClick={handleClick(o.key)}
        />
      ))}
      <input
        name={name}
        className={styles.HiddenInput}
        value={value}
        onChange={() => {}}
        required={required}
      />
    </FlexContainer>
  );
};

SelectPropertyOwnership.displayName = 'SelectPropertyOwnership';

export default SelectPropertyOwnership;
